// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/ctFMt8iIQ6O9GDelADoQ8w

import React from 'react';
import PropTypes from 'prop-types';

import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

import Editor from './TextEditor';
import { colorClassNames } from 'lib/settings';


const Text = props => {
	const {
		language,
		unsavedChanges,
		componentData,
		options,
		editorState
	} = props;

	const value = language in unsavedChanges ? unsavedChanges : componentData.value;

	const bgColor = options['background-color'];
	const bgColorClass = bgColor in colorClassNames ? colorClassNames[bgColor] : '';

	let componentClass = 'b-component b-text';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor: options['background-color'],
		columnCount: options.columnCount || 1,
	};

	if (editorState === false) {
		let localValue = '';

		if (language in value) {
			localValue = value[language];
		}

		const blocksFromHtml = htmlToDraft(localValue);
		const { contentBlocks, entityMap } = blocksFromHtml;
		const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

		// TODO: This causes a warning in console
		props.updateEditorState(localValue === '' ? EditorState.createEmpty() : EditorState.createWithContent(contentState));
	}

	return editorState ? (
		<div className={componentClass} style={style}>
			{ props.slotActive
				? <Editor
					className="b-text-source"
					slotActive={props.slotActive}
					editorState={editorState}
					changesHandler={props.changesHandler}
					updateEditorState={props.updateEditorState}
				/>
				: <div dangerouslySetInnerHTML={{__html: value[language] }} />
			}
		</div>
	) : null;
}

Text.propTypes = {
	language: PropTypes.oneOf(['fi', 'en']),
	componentData: PropTypes.shape({
		value: PropTypes.object,
	}),
	unsavedChanges: PropTypes.object,
	options: PropTypes.shape({
		layout: PropTypes.string,
	}),
	slotActive: PropTypes.bool,
	editorState: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changesHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
}

export default Text;
